function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.assign.js";
import React from 'react';
import { Link } from 'react-router-dom';
import { DateLabel } from '../../DateLabel';
import { getArticleURL, getArticleRel } from '../../Articles/utils';
import { Title, Subtitle, VideoMeta, Content, ArticleDescription } from '../partials';
import { Video } from './../Video';
export var VideoCard = function VideoCard(_ref) {
  var _video$body, _video$body$metadata;
  var video = _ref.video,
    onClick = _ref.onClick,
    _ref$withTitle = _ref.withTitle,
    withTitle = _ref$withTitle === void 0 ? true : _ref$withTitle,
    _ref$withText = _ref.withText,
    withText = _ref$withText === void 0 ? false : _ref$withText,
    _ref$withDate = _ref.withDate,
    withDate = _ref$withDate === void 0 ? false : _ref$withDate,
    _ref$withNew = _ref.withNew,
    withNew = _ref$withNew === void 0 ? false : _ref$withNew,
    _ref$thumbnailSize = _ref.thumbnailSize,
    thumbnailSize = _ref$thumbnailSize === void 0 ? 'mq' : _ref$thumbnailSize,
    _ref$dateFormat = _ref.dateFormat,
    dateFormat = _ref$dateFormat === void 0 ? 'LLL' : _ref$dateFormat;
  var handleClick = function handleClick() {
    return typeof onClick !== 'undefined' && onClick(video);
  };
  var withLink = video.body && video.alias && video.author;
  var url = withLink && getArticleURL(video);
  var rel = withLink && getArticleRel(video);
  var linkProps = url && url.startsWith('/') ? {
    to: url,
    as: Link,
    'data-fi-event': 'video',
    title: video.title,
    rel: rel
  } : {
    href: url,
    as: 'a',
    'data-fi-event': 'video',
    title: video.title,
    rel: rel
  } || {};
  var metaDescriptionTrimmed = ((video === null || video === void 0 ? void 0 : (_video$body = video.body) === null || _video$body === void 0 ? void 0 : (_video$body$metadata = _video$body.metadata) === null || _video$body$metadata === void 0 ? void 0 : _video$body$metadata.description) || '').trim();
  return React.createElement("div", null, React.createElement(Video, _extends({
    thumbnailSize: thumbnailSize,
    video: video,
    withNew: withNew
  }, typeof onClick !== 'undefined' ? {
    onClick: handleClick
  } : {})), withTitle && video.title ? React.createElement(Content, null, React.createElement(Title, _extends({}, linkProps, {
    $fontSize: withText ? 2 : 0,
    $withTopMargin: withText
  }), video.title), video.subtitle ? React.createElement(Subtitle, null, video.subtitle) : null, video.date && withDate ? React.createElement(VideoMeta, null, React.createElement(DateLabel, {
    date: new Date(video.date),
    format: dateFormat
  })) : null, withText && metaDescriptionTrimmed && React.createElement(ArticleDescription, null, metaDescriptionTrimmed)) : null);
};